<template>
  <footer class="footer">
    <div class="footer_top">
      <div class="top_start">
        <span v-if="start">
          {{start}}
        </span>
        <span v-else>
          Start your dropshipping business now
        </span>
        <div class="top_email">
          <A-Input placeholder="Enter your email address" @setInput="(e) => {this.inputData = e}"></A-Input>
          <A-Button text="Get Started" @onclick="goLink(`https://platform.antdiy.vip/#/register?email=${inputData}&source=${source}`)"></A-Button>
        </div>
      </div>
      <div class="top_us">
        <div class="top_us_left">
          <p class="top_us_title">Contact Us</p>
          <div class="top_us_email top_us_phone_text">apps@myantdiy.com</div>
          <div class="top_us_phone">
            <span class="top_us_phone_text">+44 07354 458286</span>
            <!-- <div class="top_us_phone_ts"> (General Enquiries: Monday to Friday 9:00 to 18:00 Beijing Time)</div> -->
            <div class="top_us_phone_ts"> (General Enquiries: Monday to Friday 9:00 to 18:00 UTC/GMT +8)</div>
          </div>
        </div>
        <div class="top_us_right">
          <p class="top_us_title">Follow Us</p>
          <div class="top_us_imgs">
            <img src='../../assets/facebook.svg' @click="goLink('https://www.facebook.com/ANTDIY-AliExpress-Dropshipping-Partner-112782580412393')" />
            <img src='../../assets/twitter.svg' @click="goLink('https://twitter.com/Antlinks')" />
            <img src='../../assets/reddit.svg' @click="goLink('https://www.reddit.com/r/ANTDIYdropshipping/')" />
          </div>
        </div>
      </div>
      <div class="top_content">
        <span class="top_content_title top_us_title">Address</span>
        <div class="top_content_text">
          <!-- <span>Hangzhou Office:</span>Room 203, Building 2, Taiyan Zhongchuang, Liangcang Lakeside Dream Town, Yuhang District, Hangzhou City, Zhejiang Province, China
          <br/>
          <span class="top_content_text_line"></span>
          <span>Shenzhen Office:</span>9th Floor, Block B, TCL Building, Nanyi Road, High-tech Park, Nanshan District, Shenzhen, China
          <br/>
          <span class="top_content_text_line"></span>
          <span>HongKong Office:</span>Unit A1 of Unit A,11th Floor,Success Commercial Building,245-251 Hennessy Road HongKong 999077 China -->
          Unit A1 of Unit A,11th Floor,Success Commercial Building,245-251 Hennessy Road HongKong 999077 China
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="footer_bottom_box">
        <div class="footer_bottom_link">
          <!-- <span class="footer_bottom_link_text footer_bottom_link_gang" @click="goRouter('/about')">About Us</span> -->
          <span class="footer_bottom_link_text footer_bottom_link_gang" @click="goRouter('/detail', 3)">Privacy Policy</span>
          <span class="footer_bottom_link_text footer_bottom_link_gang" @click="goRouter('/detail', 2)">Merchant Terms of Service</span>
          <span class="footer_bottom_link_text footer_bottom_link_text2" @click="goRouter('/help')">Help Center</span>
          <span class="footer_bottom_link_text" @click="goRouter('/online')">Top Stores</span>
        </div>
        <div class="footer_bottom_record" v-if="isIp">© 2023 ANTDIY All Rights Reserved. <a href="https://beian.miit.gov.cn/">浙ICP备19046082号</a></div>
        <div class="footer_bottom_record" v-else>© ANTLINKS All Rights Reserved.</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: ['record', 'link', 'isIp','start'],
  data () {
    return {
      inputData: '',
      source: localStorage.getItem('ant_source') || ''
    }
  },
  methods: {
    goRouter (router, id) {
      let query
      if (id) {
        query = {p: id}
      }
      this.$router.push({
        path: router,
        query
      }).catch(err => {
        console.log('e',err)
      })
    },
    goLink (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>
  .footer{
    width: 100%;
    background: #32404D;
  }
  .footer_top{
    width: 1200px;
    margin: 0 auto;
  }
  .top_start{
    padding-top: 72px;
    display: flex;
    justify-content: space-between;
  }
  .top_start > span{
    font-size: 32px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 40px;
  }
  .top_email{
    font-size: 0;
  }
  .ad_input{
    margin-right: -1px;
  }
  .top_us{
    padding-top: 89px;
    display: flex;
    justify-content: space-between;
  }
  .top_us_title{
    font-size: 16px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 32px;
    opacity: 0.5;
  }
  .top_us_email{
    margin: 12px 0;
  }
  .top_us_phone_text{
    font-size: 28px;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 40px;
    display: inline-block;
  }
  .top_us_phone_ts{
    display: inline-block;
    font-size: 16px;
    font-family: Helvetica;
    color: #8D919B;
    line-height: 32px;
    margin-left: 28px;
  }
  .top_us_imgs{
    margin-top: 21px;
  }
  .top_us_imgs img{
    width: 48px;
    height: 48px;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 100%;
  }
  .top_us_imgs img:hover{
    background-color: rgba(255, 255, 255, 0.2);
  }
  .top_us_imgs img + img{
    margin-left: 40px;
  }
  .top_content{
    padding: 40px 0;
  }
  .top_content_title{
    font-weight: bold;
  }
  .top_content_text{
    font-size: 16px;
    font-family: Helvetica;
    color: #FFFFFF;
    line-height: 32px;
    margin: 12px 0;
  }
  .footer_bottom{
    background: rgba(0, 0, 0, 0.09);
  }
  .footer_bottom_box{
    width: 1200px;
    margin: 0 auto;
  }
  .footer_bottom_link{
    padding-top: 62px;
  }
  .footer_bottom_link_text{
    font-size: 16px;
    font-family: Helvetica;
    color: #8D919B;
    line-height: 16px;
    position: relative;
    cursor: pointer;
  }
  .footer_bottom_link_text:hover, .footer_bottom_link_text:focus, .footer_bottom_link_text:active{
    color: #FC5322;
  }
  .footer_bottom_link_text + .footer_bottom_link_text{
    margin-left: 82px;
  }
  .footer_bottom_link_gang:after{
    content: '';
    width: 1px;
    height: 13px;
    background: #FFFFFF;
    position: absolute;
    right: -40px;
    top: 1px;
  }
  .footer_bottom_link_text2:after{
    content: '';
    width: 1px;
    height: 13px;
    background: #FFFFFF;
    position: absolute;
    right: -40px;
    top: 1px;
  }
  .footer_bottom_record{
    font-size: 16px;
    font-family: Helvetica;
    color: #8D919B;
    line-height: 32px;
    padding: 33px 0 63px;
  }

  .footer_bottom_record a{
    color: #fc5322;
  }

  @media (max-width: 767px){
    .footer_top {
      width: 100%;
      padding: .77rem .46rem .62rem;
    }
    .top_start{
      flex-direction: column;
      padding: 0;
    }
    .top_start > span{
      text-align: center;
      font-size: .31rem;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #FFFFFF;
      line-height: .38rem;
    }
    .ad_input{
      width: 100%;
      margin: .37rem 0;
      text-align: center;
      border-radius: 6px;
    }
    .ad_button{
      width: 100%;
      text-align: center;
      border-radius: 6px;
    }
    .top_us{
      padding-top: .61rem;
      text-align: center;
      flex-direction: column;
    }
    .top_us_title{
      font-size: .23rem;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #FFFFFF;
      line-height: .46rem;
      opacity: 1;
    }
    .top_us_email{
      margin: .17rem 0;
    }
    .top_us_phone_text{
      font-size: .4rem;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #FFFFFF;
      line-height: .58rem;
    }
    .top_us_phone_ts{
      margin-left: 0;
      font-size: .23rem;
      font-family: Helvetica;
      color: #8D919B;
      line-height: .46rem;
      margin: 0 -.2rem;
    }
    .top_content{
      padding: .61rem 0 0;
      text-align: center;
    }
    .top_content_text{
      font-size: .23rem;
      font-family: Helvetica;
      /* font-weight: bold; */
      color: #FFFFFF;
      line-height: .38rem;
      opacity: 0.5;
      margin: .17rem 0;
    }
    .top_content_text >span{
      display: block;
    }
    .top_content_text_line{
      display: block;
      height: .24rem;
    }
    .footer_bottom_box{
      width: 100%;
      padding: .3rem .46rem;
    }
    .footer_bottom_link{
      padding: 0;
      display: none;
    }
    .footer_bottom_link_text{
      font-size: .23rem;
      line-height: .46rem;
      display: block;
      margin: 0 0 .16rem 0 !important;
    }
    .footer_bottom_link_gang, .footer_bottom_link_text{
      /* margin: 0 !important; */
    }
    .footer_bottom_record{
      font-size: .23rem;
      line-height: .46rem;
      padding: 0;
      text-align: center;
    }
    .top_us_right{
      margin-top: .61rem;
    }
  }  
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue